import * as Yup from "yup";

export const TWO_FACTOR_AUTH_OTP_SCHEMA = Yup.object().shape({
  otp: Yup.string()
    .required("Please enter your OTP code.")
    .min(6, "Your OTP code must be at least 6 characters long.")
    .max(6, "Your OTP code must be at most 6 characters long."),
});
